// extracted by mini-css-extract-plugin
export default {"wrapper":"_d327e570","editButton":"_4936daa9","deleteButton":"_58374d0c","trashIcon":"_d0707954"};